export const COMPLETE_YOUR_PROFILE_1_ID = 616;
export const COMPLETE_YOUR_PROFILE_2_ID = 617;
export const NEW_PROFILE_SURVEY_ID = 836;
export const END_OF_SURVEY = 'end_of_survey';
export const REDIRECT_END_OF_SURVEY = 302;
